export type AppReadyState = {
  initialQueriesComplete: boolean;
  minTimeSponsorShown: boolean;
};

export const APP_READY_STATE_INITIAL: AppReadyState = {
  initialQueriesComplete: false,
  minTimeSponsorShown: false,
};
